module.exports = __webpack_public_path__ + "static/media/Zamora-Drywall-Inc (25).04bcc05a.jpg";